import { groupEntityName } from '../../../../../../backend/features/groups/shared';
import { useContactManagementTranslation, useUserState } from '../../../../../../ui/hooks';
import { DataTable, TextCell, useDataTableUsingState } from '@juvare/common-data-table-ui/DataTable';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { useEntityDataTable } from '@juvare/platform-sdk-react/ui/hooks';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import { mapGroupFilter } from '../../../hooks/useGroupList';
import { useGroupsFilterConfig } from '../../../hooks/useGroupsFilterConfig';
export function showGroupsDialog(params) {
    showCustomDialog({
        fullWidth: true,
        maxWidth: 'md',
        content: (close) => React.createElement(GroupsDialogComponent, Object.assign({}, params, { close: close })),
    });
}
export const GroupsDialogComponent = (props) => {
    const userState = useUserState();
    const { t } = useContactManagementTranslation();
    const columns = React.useMemo(() => [
        {
            headerLabel: t('panels.groups.name'),
            cellFunction: (row) => React.createElement(TextCell, null, row.columns.name),
            sortKey: 'name',
        },
    ], [t]);
    const { dataTableProps } = useEntityDataTable({
        title: '',
        entityName: groupEntityName,
        mapEntityFilterData: (filterData) => mapGroupFilter(userState, filterData, !props.excludeFilterBasedGroups, props.selectedGroupId),
        filterConfig: useGroupsFilterConfig(),
        columns: columns,
        defaultSortColumnKey: 'name',
    }, {
        useDataTableFunction: useDataTableUsingState,
        onRowClick: () => undefined,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, null, t('panels.groups.selectGroup')),
        React.createElement(DialogContent, null, userState && React.createElement(DataTable, Object.assign({}, dataTableProps, { "data-test": 'groups-table' }))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: () => props.close() }, t('common.cancel')),
            React.createElement(Button, { color: 'primary', disabled: !dataTableProps.activeRowId, onClick: () => {
                    props.close(() => {
                        if (dataTableProps.activeRowId) {
                            props.onSelect(dataTableProps.activeRowId);
                        }
                    });
                } }, t('common.select')))));
};
